import React from "react";

import queryString from "query-string";

import MainBodyTabs from "../common/MainBodyTabs";
import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";
import Routes from "./Routes";

import lbl from "../../data/Labels.json";

const TeacherProfile = (props) => {
  const { staffName } = queryString.parse(props.location.search);

  const tabs = [
    {
      name: "اطلاعات عمومی",
      path: "",
      urlParams: `staffName=${staffName}`,
    },
    {
      name: "معاشات",
      path: "salary",
      urlParams: `staffName=${staffName}`,
    },
    {
      name: "قرارداد ها",
      path: "contracts",
      urlParams: `staffName=${staffName}`,
    },
    { name: "کتابخانه", path: "", urlParams: `staffName=${staffName}` },
  ];

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={staffName} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={tabs} {...props} />
        <Routes {...props} />
      </div>
    </div>
  );
};

export default TeacherProfile;
